module.exports = __webpack_public_path__ + "static/media/Step3.26d97829.png";